import { DefaultTheme } from 'styled-components';
import { ButtonVariantsEnum } from '../Button.types';
import * as variants from '../variants';

type GetButtonVariantStyles = (args: {
  theme: DefaultTheme;
  isFocused?: boolean;
}) => Record<ButtonVariantsEnum, string>;

export const getButtonVariantStyles: GetButtonVariantStyles = ({
  theme,
  isFocused = false,
}) => {
  const { brand, button, text, commons } = theme.palette,
    isDefaultVariant = !brand.linear_gradient;

  return {
    [ButtonVariantsEnum.Primary]: isDefaultVariant
      ? variants.primary.default({ button })
      : variants.primary.withLinearGradient({ button }),

    [ButtonVariantsEnum.Secondary]: isDefaultVariant
      ? variants.secondary.default({ button })
      : variants.secondary.withLinearGradient({ button, brand }),

    [ButtonVariantsEnum.SecondaryWhite]: variants.secondaryWhite({
      button,
      text,
      commons,
    }),
    [ButtonVariantsEnum.Outlined]: variants.outlined({ button }, isFocused),
    [ButtonVariantsEnum.OutlinedWithoutBackground]:
      variants.outlinedWithoutBackground({
        button,
      }),
    [ButtonVariantsEnum.TextLink]: variants.textLink({ text }),
    [ButtonVariantsEnum.Select]: variants.select({ button }),
  };
};
